
function Review(props) {
  const stars = new Array(true,true,true,true,true);
  
  return (
    <div className="review" id={props.id} style={{'width':'100%', 'gridTemplateColumns':'auto'}}>
      <div>
        <div>
          <div>
            {stars.map((el, idx) => {
              if (idx + 1 <= props.rate) {
                return <span className="mFont checked" id={idx}>star</span>;
              } else {
                return <span className="mFont" id={idx}>star</span>;
              }
            })}
          </div>
          <h5> {props.date} </h5>
        </div>
        <p>{props.description}</p>
      </div>
    </div>
  );
}

export default Review;
